import { baseURL } from "config/index";

const stagingApiUrls = {
  baseURL: baseURL,
};

export default stagingApiUrls;
